module.exports = __webpack_public_path__ + "static/media/goat-finding-its-way.edc9fb00.gif";